export const convertDate = (data?: string) => {
  const date = new Date(data!);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); 
  const year = date.getFullYear();
  const formatDate = `${day}/${month}/${year}`;

  return formatDate
}